export default __webpack_public_path__ + "static/17-2e6864d8f09223b68d9a805cbfb51953.jpg";